import { Button } from "antd";

export function PillButton({
  title,
  onClick,
  color,
  backgroundColor,
  id,
  disabled,
  loading,
}: {
  disabled?: boolean;
  loading?: boolean;
  id?: string;
  title: string;
  onClick: () => void;
  color?: string;
  backgroundColor?: string;
}) {
  return (
    <Button
      className="bg-gradient-to-r from-purple-600 to-blue-600"
      id={id}
      loading={loading}
      type="text"
      onClick={onClick}
      style={{
        borderRadius: 40,
        color: color ?? "white",
        fontSize: 35,
        padding: "30px 40px",
      }}
      disabled={disabled}
    >
      {title}
    </Button>
  );
}
